import {Empty} from "antd";
import React from "react";

const EmptyDataCard = ({message = 'No data found'}) => {
    return (<div className={'ch-empty-data-card flexColumn'}><p className={'ch-bold'}>{message}</p><Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/></div>)
}

export default EmptyDataCard;
